import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { wait } from "../../../utils/utils";
import postMessageBridgeTypes from "../../../enums/postMessageBridgeTypes";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import classes from './DelayNavigatePage.module.css'

const DelayNavigatePage = () => {

    const { texts } = useSelector(state => state.translate);
    const generalData = useSelector((state) => state.uiData.general);
    // eslint-disable-next-line no-unused-vars
    const { link, reloadOpener } = useParams();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (generalData) {
            (async () => {
                // try {
                //     if (parseInt(reloadOpener)) {
                //         window.opener.location.reload();
                //     }
                // }
                // catch (e) {
                //     console.error(e);
                // }
                if (link) {
                    let decodeLink = decodeLinkIfNeeded(link);
                    if (window.opener && decodeLink?.startsWith("http")) {
                        try {
                            window.opener.postMessage(
                                {
                                    type: postMessageBridgeTypes.PLATFORM_REDIRECT,
                                    link: decodeLink,
                                    ga: {
                                        section: searchParams.get("gaSection") || undefined,
                                        sectionValue: searchParams.get("gaSectionValue") || undefined,
                                    },
                                },
                                window.location.origin
                            );
                        } catch (e) {
                            console.error(e);
                        }
                        window.opener = null;
                    }
                    await wait(generalData?.delayNavigatePageTime)
                    navigateToPage(decodeLink)
                }
            })()
        }
    }, [generalData, link, searchParams])

    const decodeLinkIfNeeded = (link) => {
        if (link.startsWith('ENCODED_')) {
            const base64Link = link.replace('ENCODED_', '');
            return decodeURIComponent(atob(base64Link));
        }
        return link;
    };

    const navigateToPage = (link) => {
        window.location.href = link;
    }

    return (
        <div className={classes.DelayNavigatePage}>
            <AccessibilityHiddenImg className={classes.Img} src={generalData?.waitNavigatePageGif} />
            <h1 id="main" className={classes.Title}>{texts.delayNavigatePageTitle}</h1>
            <p className={classes.Text}>{texts.navigateToPage}</p>
        </div>
    )
}

export default DelayNavigatePage;
